import { render, staticRenderFns } from "./GoverningBodies.vue?vue&type=template&id=087a5b41"
import script from "./GoverningBodies.vue?vue&type=script&lang=js"
export * from "./GoverningBodies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports